/*
 * Arial Black is not supported by iOS (https://developer.apple.com/fonts/system-fonts/)
 * and there is an open discussion of iOS randomly refusing to download custom fonts: https://developer.apple.com/forums/thread/671608
 * Also it is not listed on either big font provider service (Google Fonts, Adobe Fonts, etc.)
 * Arial-BoldMT added as a fallback for iOS to stay as close to design as possible
 */
export const ARIAL_BLACK_FONT_FAMILY = "'Arial Black', Arial-BoldMT, sans-serif";
